import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  CREATE_ASSOCIATES,
  DELETE_ASSOCIATES,
  GET_ASSOCIATES,
  GET_SUMMARY_ASSOCIATES,
  GET_ORDER_ASSOCIATES,
  UPDATE_ASSOCIATES,
  CHECK_CPF_CUSTOMER,
} from './actionType';

import {
  AssociatesApiResponseSuccess,
  AssociatesApiResponseError,
} from './action';

import {
  getAssociates as associatesGet,
  getSummaryAssociates as associatesGetSummary,
  getOrderAssociates as associatesGetOrder,
  createAssociates as associatesCreate,
  updateAssociates as associatesUpdate,
  deleteAssociates as associatesDelete,
  checkCpfProposal,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';
import {
  ProposalApiResponseError,
  ProposalApiResponseSuccess,
} from '../proposal/action';
import { CHECK_CPF_PROPOSAL } from '../proposal/actionType';
import { cpf } from 'cpf-cnpj-validator';

function* getAssociates() {
  try {
    const response = yield call(associatesGet);
    yield put(AssociatesApiResponseSuccess(GET_ASSOCIATES, response));
  } catch (error) {
    yield put(AssociatesApiResponseError(GET_ASSOCIATES, error));
  }
}

function* getSummaryAssociates() {
  try {
    const response = yield call(associatesGetSummary);
    yield put(AssociatesApiResponseSuccess(GET_SUMMARY_ASSOCIATES, response));
  } catch (error) {
    yield put(AssociatesApiResponseError(GET_SUMMARY_ASSOCIATES, error));
  }
}

function* getOrderAssociates({ payload }) {
  const { page, length, search, order_column, order_dir } = payload;
  try {
    const response = yield call(associatesGetOrder, {
      page,
      length,
      search,
      order_column,
      order_dir,
    });
    yield put(AssociatesApiResponseSuccess(GET_ORDER_ASSOCIATES, response));
  } catch (error) {
    yield put(AssociatesApiResponseError(GET_ORDER_ASSOCIATES, error));
  }
}

function* createAssociates({ payload }) {
  const { history, data } = payload;
  try {
    const response = yield call(associatesCreate, data);
    yield put(AssociatesApiResponseSuccess(CREATE_ASSOCIATES, response));

    // if (data.payload.goToProposals) {
    //   data.payload.history.push(`/propostas/list/${response.id}`);
    // }
    notifySuccess('Associado criado com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(AssociatesApiResponseError(CREATE_ASSOCIATES, error));
    notifyError('Erro ao criar associado!');
  }
}

function* updateAssociates({ payload }) {
  const { history, ...data } = payload;

  try {
    const response = yield call(associatesUpdate, data);
    yield put(AssociatesApiResponseSuccess(UPDATE_ASSOCIATES, response));
    notifySuccess('Associado atualizado com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(AssociatesApiResponseError(UPDATE_ASSOCIATES, error));
    notifyError('Erro ao atualizar associado!');
  }
}

function* deleteAssociates(data) {
  try {
    const response = yield call(associatesDelete, data.payload.id);
    yield put(AssociatesApiResponseSuccess(DELETE_ASSOCIATES, response));
    notifySuccess('Associado deletado com sucesso!');
  } catch (error) {
    yield put(AssociatesApiResponseError(DELETE_ASSOCIATES, error));
    notifyError('Erro ao deletar associado!');
  }
}

function* checkCustomerCpf(data) {
  try {
    const response = yield call(checkCpfProposal, data.payload.cpf);
    yield put(ProposalApiResponseSuccess(CHECK_CPF_PROPOSAL, response));
    data.payload.history.push(`/associados/edit/${response.customer.hashid}`);
  } catch (error) {
    yield put(ProposalApiResponseError(CHECK_CPF_PROPOSAL, error));
    data.payload.history.push(
      `/associados/novo/proposal?cpf=${data.payload.cpf}`
    );
  }
}

export function* watchCheckCpf() {
  yield takeEvery(CHECK_CPF_CUSTOMER, checkCustomerCpf);
}
export function* watchGetAssociates() {
  yield takeEvery(GET_ASSOCIATES, getAssociates);
}

export function* watchGetSummaryAssociates() {
  yield takeEvery(GET_SUMMARY_ASSOCIATES, getSummaryAssociates);
}

export function* watchGetOrderAssociates() {
  yield takeEvery(GET_ORDER_ASSOCIATES, getOrderAssociates);
}

export function* watchCreateAssociates() {
  yield takeEvery(CREATE_ASSOCIATES, createAssociates);
}

export function* watchUpdateAssociates() {
  yield takeEvery(UPDATE_ASSOCIATES, updateAssociates);
}

export function* watchDeleteAssociates() {
  yield takeEvery(DELETE_ASSOCIATES, deleteAssociates);
}

function* AssociatesSaga() {
  yield all([fork(watchGetAssociates)]);
  yield all([fork(watchGetSummaryAssociates)]);
  yield all([fork(watchCreateAssociates)]);
  yield all([fork(watchUpdateAssociates)]);
  yield all([fork(watchDeleteAssociates)]);
  yield all([fork(watchGetOrderAssociates)]);
  yield all([fork(watchCheckCpf)]);
}

export default AssociatesSaga;
